import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`


/* reset */
body {min-width: 360px; color: #393E47; font-family: "NotoSanskr", sans-serif; font-weight: 400;}
h1, h2, h3, h4, h5, h6 {margin-bottom: 0; color: #393E47; font-weight: 800; font-size: 16px;} 
ul, ol, li, dl, dt, dd {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

p {margin: 0;}
/* layout */
.body-container {
    height: 100vh;
    
}

.ant-layout-content {overflow-y: auto;}




/* 공통 클래스 */
.b {
  font-weight: 800 !important;
}

.float-left {
  float: left;
}

.float-right{
  float: right;
}

/* font-weight */
.fwn {
  font-weight: 400 !important;
  & label {
    font-weight: 400 !important;
  }
}

.fwb {
  font-weight: 800 !important;
}
/*마진,패딩 클래스*/
.mt0 {
  margin-top: 0 !important;
}
.mt05 {
  margin-top: 5px !important;
}
.mt10 {
  margin-top: 10px !important;
}

.mt15 {
  margin-top: 15px !important;
}

.mt20 {
  margin-top: 20px !important;
}
.mt25 {
  margin-top: 25px !important;
}
.mt28 {
  margin-top: 28px !important;
}
.mt30 {
  margin-top: 30px !important;
}
.mt35 {
  margin-top: 35px !important;
}
.mt40 {
  margin-top: 40px !important;
}


.mb0 {
  margin-bottom: 0px !important;
}
.mb02 {
  margin-bottom: 2px !important;
}
.mb05 {
  margin-bottom: 5px !important;
}
.mb10 {
  margin-bottom: 10px !important;
}

.mb15 {
  margin-bottom: 15px !important;
}
.mb20 {
  margin-bottom: 20px !important;
}
.mb25 {
  margin-bottom: 25px !important;
}
.mb30 {
  margin-bottom: 30px !important;
}
.mb35 {
  margin-bottom: 35px !important;
}
.mb40 {
  margin-bottom: 40px !important;
}

.ml0 {
  margin-left: 0 !important;
}
.ml05 {
  margin-left: 5px !important;
}
.ml10 {
  margin-left: 10px !important;
}
.ml15 {
  margin-left: 15px !important;
}
.ml20 {
  margin-left: 20px !important;
}

.ml25 {
  margin-left: 25px !important;
}
.ml30 {
  margin-left: 30px !important;
}
.ml35 {
  margin-left: 35px !important;
}
.ml40 {
  margin-left: 40px !important;
}


.mr0 {
  margin-right: 0 !important;
}
.mr05 {
  margin-right: 5px !important;
}
.mr10 {
  margin-right: 10px !important;
}
.mr15 {
  margin-right: 15px !important;
}
.mr20 {
  margin-right: 20px !important;
}
.mr25 {
  margin-right: 25px !important;
}
.mr30 {
  margin-right: 30px !important;
}
.mr35 {
  margin-right: 35px !important;
}
.mr40 {
  margin-right: 40px !important;
}


.pt0 {
  padding-top: 0 !important;
}
.pt05 {
  padding-top: 5px !important;
}
.pt10 {
  padding-top: 10px !important;
}
.pt15 {
  padding-top: 15px !important;
}
.pt20 {
  padding-top: 20px !important;
}
.pt25 {
  padding-top: 25px !important;
}
.pt30 {
  padding-top: 30px !important;
}
.pt35 {
  padding-top: 35px !important;
}
.pt40 {
  padding-top: 40px !important;
}
.pt45 {
  padding-top: 45px !important;
}
.pt50 {
  padding-top: 50px !important;
}

.pb0 {
  padding-bottom: 0 !important;
}
.pb05 {
  padding-bottom: 5px !important;
}
.pb10 {
  padding-bottom: 10px !important;
}
.pb15 {
  padding-bottom: 15px !important;
}
.pb20 {
  padding-bottom: 20px !important;
}
.pb25 {
  padding-bottom: 25px !important;
}
.pb30 {
  padding-bottom: 30px !important;
}
.pb33 {
  padding-bottom: 33px !important;
}
.pb35 {
  padding-bottom: 35px !important;
}
.pb40 {
  padding-bottom: 40px !important;
}
.pb45 {
  padding-bottom: 45px !important;
}
.pb50 {
  padding-bottom: 50px !important;
}

.pl0 {
  padding-left: 0 !important;
}
.pl05 {
  padding-left: 5px !important;
}
.pl10 {
  padding-left: 10px !important;
}
.pl15 {
  padding-left: 15px !important;
}
.pl20 {
  padding-left: 20px !important;
}
.pl22 {
  padding-left: 22px !important;
}

.pl25 {
  padding-left: 25px !important;
}
.pl30 {
  padding-left: 30px !important;
}
.pl35 {
  padding-left: 35px !important;
}
.pl40 {
  padding-left: 40px !important;
}


.pr0 {
  padding-right: 0 !important;
}
.pr05 {
  padding-right: 5px !important;
}
.pr10 {
  padding-right: 10px !important;
}
.pr15 {
  padding-right: 15px !important;
}
.pr20 {
  padding-right: 20px !important;
}
.pr25 {
  padding-right: 25px !important;
}
.pr30 {
  padding-right: 30px !important;
}
.pr35 {
  padding-right: 35px !important;
}
.pr40 {
  padding-right: 40px !important;
}


/******************************
  ant Design Customizing 
/******************************/

/* Modal */
/* 화면이 길어질 경우 body에 스크롤 생기지 않도록 처리 > 모달내부에 스크롤 생겨야 함. */
.ant-modal-wrap {
  overflow: hidden;
  & .ant-modal, & .ant-modal-content {
    max-height: 90vh;
  }
  & .ant-modal-content {
    display: flex;
    flex-direction: column;
    & .ant-modal-body {
      display: flex;
      flex-direction: column ;
      overflow: hidden auto;
    }
  }
}

.ant-modal-header {
  border-bottom: 0;
  padding: 35px 45px;
  line-height: 29px;
  & .ant-modal-title {
    font-weight: 800;
    font-size: 20px;
  }
}

& .ant-modal-close {
  width: 92px;
  height: 92px;
  line-height: 92px;
  & .ant-modal-close-x {
    width: 100%;
    height: 100%;
    line-height: 92px;
    color: #393E47;
  }
}

.ant-modal-footer {
  border-top: 0;
  padding: 35px 45px;
  & .ant-btn {
    min-width: 112px;
  }
  @media all and (max-width: 767px) {
    & .ant-btn {
      min-width: initial;
    }
  }
}

.ant-modal-body {
  padding: 0 45px;
}

.ant-modal-body .section-tit-area  {
  & .page-tit-p {
    font-size: 20px;
  }
  & + .ant-row.ant-form-item {
    margin-top: 17px;
  }
}

/* Modal 모바일 */
@media all and (max-width: 767px) {
  & .ant-modal-centered::before {content: none} /* 화면을 가로로 줄였을때 모달이 사라지는 현상 제거 */
  & .ant-modal-wrap .ant-modal:not([class*="ant-modal-"]) {
    width: 100vw !important;
    max-width: 100vw;
    height: 100vh !important;
    max-height: 100vh;
    margin: 0;
    top: 0;
    & .ant-modal-content {
      height: 100vh;
      max-height: 100vh;
      & .ant-modal-body {
        flex: 1 1 auto;
      }
    }
  }
  & .ant-modal-header {
    padding: 20px 20px;
    
  }

  & .ant-modal-close {
  width: 56px;
  height: 56px;
  line-height: 56px;
    & .ant-modal-close-x {
      line-height: 56px;
    }
  }

  .ant-modal-footer {
    padding: 20px 20px;
    display: flex;
    & button {
      flex: 1 1 50%;
    }
  }

  .ant-modal-body {
    padding: 0 20px;
  }
} /* Modal 모바일 */

/* Form */
/* Form  - Row 간 간격 조정 */
& .ant-form > .ant-row.ant-form-item {
  margin-bottom: 0;
  color: #5E6675;
  
 
 & > .ant-col {
   margin-bottom: 10px;
   & .ant-row.ant-form-item {
      margin-bottom: 0;
   }
 }

 &:last-child > .ant-col { margin-bottom: 0;}

 @media all and (max-width: 767px) {
    & .ant-row:not(.ant-form-item){
      & > .ant-col:not(:last-child) {
        margin-bottom: 10px;
      }
    }
    & .ant-col.ant-col-sm-24 {
      width: 100%;
    }
  }

  @media all and (max-width: 575px) {
    .ant-col.ant-form-item-label {
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
  
} /* Form  - Row 간 간격 조정 */

& .ant-form hr {
  border:0;
  background: #D8DBE3;
  height: 1px;
  margin: 14px 0 24px 0; 
}

& .ant-form-item-label  {
  text-align: left;
  & > label {
    color: #5E6675;
    font-size: 13px;
    font-weight: 800;
  } 
}
& .ant-form-item-label > label::after {
  content: none;
}
& .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  content: none;
}
& .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
  display: inline-block;
  margin-left: 2px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
  top: -3px;
}

/* Form - label 너비 px 단위 추가 */
& .label-w-100 .ant-form-item-label{
     width: 120px;
}

& .label-w-120 .ant-form-item-label{
     width: 120px;
}

& .label-w-130 .ant-form-item-label{
     width: 130px;
}
& .label-w-150 .ant-form-item-label{
     width: 150px;
}
& .label-w-180 .ant-form-item-label{
     width: 180px;
}
& .label-w-200 .ant-form-item-label{
     width: 200px;
}

/* 서비스변경 : top + left 혼합 헤더형 폼 */
& .frm-top-header {
    display: inline-block;
    & .top-header {
      font-size: 13px;
      font-weight: 800;
    }
    & .ant-space-item {
        white-space: nowrap;
    }
    & .label-only-mob .ant-form-item-label{
      display: none;
    }

    @media all and (max-width: 767px) {
      display: block;
      & .top-header {
         display: none;
      }
      & .label-only-mob {
        display: block;
        .ant-form-item-label{
          display: inline-block;
          width: auto !important;
          padding-right: 20px;
          & > label {
            font-weight: 400;
          }
        }
        .ant-form-item-control {
          display: inline-block;
        }
      }
    }
}




/* Button : 기본타입 흰색, primary 파란색*/
.ant-btn {
  font-size: 13px;
}
.ant-btn-primary {
  background: #1A65BC;
  border-color: #1A65BC;
}

.ant-btn-primary:hover, 
.ant-btn-primary:focus{
  background: #1487EF;
  border-color: #1487EF;
}

.ant-btn.btn-gray {
  background: #7A8599;
  border-color: #7A8599;
  color: #fff;
}

.ant-btn.btn-gray:hover, 
.ant-btn.btn-gray:focus{
  background: #9faabf;
  border-color: #9faabf;
}

.ant-btn.btn-lightBlue {
  background: #1487EF;
  border-color: #1487EF;
  color: #fff;
}

.ant-btn.btn-lightBlue:hover, 
.ant-btn.btn-lightBlue:focus{
  background: #3297f1;
  border-color: #3297f1;
}

.ant-btn.btn-ico-del {
  color: #EF5D5D;
}

.ant-btn.btn-ico-del:hover, 
.ant-btn.btn-ico-del:focus{
  color: #e76565;
  border: 1px solid #d9d9d9;
}

.ant-btn.btn-ico-only {
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 24px;
  height: 24px;
}

.btn-wide {
  min-width: 112px;
}

/* 여백이 좁은 버튼 */
.btn-compact {
  padding-left: 8px; 
  padding-right: 8px;
}

/* 파란색 링크 텍스트버튼 */
& .btn-link {
    padding: 0;
    border: 0;
    background: transparent;
    color: #1A65BC;

    &:hover, &:focus, &:active {
      background: transparent;
    }

    &:hover span {
        text-decoration: underline;
    }
    &[ant-click-animating-without-extra-node='true']::after {
        display: none;
    }
    
}  

/* Input - Search */
.ant-input-search {
  position: relative;
  background: #fff;
  & .ant-input {
    background: transparent;
  }
  & .ant-input-group-addon {
    background: transparent;
    position: absolute;
      right: 0;
      left: auto !important;
      top: 0;
      width: 32px;
      z-index: 1;
      cursor: pointer;
    & .ant-btn {
      background: transparent;
      border: 0;
      cursor: pointer;
    }
  }
  
}
/* Sidebar */
.ant-layout-sider-zero-width-trigger {
    top: 0;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    left: auto;
    border: 1px solid #ddd;
}
@media all and (max-width: 992px) {
  .ant-layout-sider-light {
    position: absolute;
    height: calc(100% - 65px);
    z-index: 99;
  }
}

/* Table */
.ant-table {
  font-size: 15px;
  color: #5E6675;
}
.ant-table-thead > tr > th {
  font-weight: 800;
  color: #5E6675;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table {
  border-top: 1px solid #D8DBE3;
}
.ant-table-thead > tr > th {
  background: #F7F8FA;
  border-bottom: 1px solid #D8DBE3;
  text-align: center !important;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr:not(:last-child) > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr:not(:last-child) > th {
  border-bottom: 1px solid #D8DBE3;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > td {
  border-right: 1px solid #D8DBE3;
}

.ant-table-column-title {
  white-space: nowrap;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid #D8DBE3;
  text-align: center;
  font-weight: 400;
  & .ant-empty  {
    height: 200px; 
    display: flex;
    align-items: center ;
    justify-content: center ;
    flex-direction: column ;
  }
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: 0;
  padding: 0;
  &::after {
    border-right: 0;
  }
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > th:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td:last-child, 
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > td:last-child {
  border-right: 0;
}

.ant-table.ant-table-bordered > .ant-table-container {
  border-left: 0;
}

.ant-table-tbody > tr.ant-table-row:hover > td, .ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background: rgba(26, 101, 188, 0.1);
}

.ant-table-thead > tr > th, .ant-table-tbody > tr > td, .ant-table tfoot > tr > th, .ant-table tfoot > tr > td {
  padding: 6px 10px;
  height: 46px;
  line-height: 1.2;
}

.ant-table-body {
  overflow: auto !important;
}

.ant-table-ping-right:not(.ant-table-has-fix-right) .ant-table-container::after {
  box-shadow: none;
}

/* 
 테이블 resize 기능이 있는 페이지 커스텀 클래스 
 페이지 클래스 .has-table-resize
 table-wrpper 클래스 .tbl-resize-wrapper
*/
.has-table-resize {
  display: flex;
  flex-direction: column ;
  max-height: 100%; 
  .tbl-resize-wrapper {
        /* position: sticky;
        top: 0; */
        flex: 1 1 auto;
        overflow:auto;
        height: 100%;
        border-top: 1px solid #D8DBE3;
        & > .ant-table-wrapper {
                .ant-table-content {
                    overflow: initial !important;
                    & table {
                        border-top: 0 !important;
                    }
                    & thead {
                        position: sticky;
                        top: 0;
                        z-index:1; 
                    }
                }
        }
    }
    @media all and (orientation:landscape) and (max-width: 763px) {
      & {
        max-height: initial;
        .tbl-resize-wrapper {
          height: auto;
        }
      }
    }
} 
/* .ant-modal-body .has-table-resize {
  max-height: calc(100% - )
} */
/* 테이블 resize 기능이 있는 페이지 커스텀 클래스 */

/* Select - multiple 옵션이 있는 select , 선택했을때 4글자까지만 표시 */
.ant-select-multiple .ant-select-selection-item {
  max-width: 6em;
}

.ant-select-item-option-content {
  order: 1;
  height: 24px;
  &:last-child {
    // 멀티 셀렉트: 선택되지 않은 상태
    padding-left: 30px;
    position: relative;
    &::before {
      width: 24px;
      height: 24px;
      border: 1px solid #1487EF;
      position: absolute;
      left: 0;
      content: '';
      background: #ffffff;
    }
  }
  
}

.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  font-weight: 400;
}

.ant-select-item-option-state:not(:empty) {

  // 멀티 셀렉트: 선택된 상태
  color: #1a65bc;
  width: 24px;
  height: 24px;
  border: 1px solid #1487EF;
  margin-right: 6px;
  background: #ffffff;
  & .anticon-check {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin: 0;
    & svg {
      color: #1A65BC;
      font-size: 17px;
    }
  }
}


/* Statistic */

.ant-statistic-content {
  font-size: 14px;
  font-family: "NotoSanskr", sans-serif; 
  font-weight: 400;
}
/* Empty */
.ant-empty.ant-empty-normal {
  margin: 0;
}

/* Radio Group - optionType(button) */
.ant-radio-group  {
  .ant-radio-button-wrapper {
    margin-right: 4px;
    border-radius: 2px;
    /* min-width: 85px; */
    text-align: center;
    &:last-child {
      margin-right: 0;
    }
    &.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper {
      border-color: #1487EF;
      background: #1487EF;
    }
  }

  @media all and (max-width: 479px) {
    .ant-radio-button-wrapper {
      /* min-width: initial; */
    }
  }

}


/* CheckBox, Tree > CheckBox */
& .ant-checkbox-wrapper {
  align-items: center;
  & .ant-tree-checkbox {
    top: auto;
  }
}
& .ant-checkbox-inner,
& .ant-tree-checkbox-inner {
  width: 24px; 
  height: 24px;
}
& .ant-checkbox-checked .ant-checkbox-inner,
& .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
  background: #ffffff;
  border-color: #1A65BC;
 
  &::after {
    border-color: #1A65BC;
    width: 8px;
    height: 14px;
    top: 45%;
    left: 22%;
  }
}

& .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {
  background-color: #1A65BC;
}

& .ant-tree .ant-tree-treenode {
  padding-bottom: 12px;
}

& .ant-tree-checkbox {
  margin-top: 0;
}




/******************************
  Swiper Design Customizing
/******************************/
.swiper-button-prev:after, 
.swiper-button-next:after {
  content: '';
  border-left: 5px solid #fff;
  border-bottom: 5px solid #fff;
  width: 22px;
  height: 22px;
  border-radius:2px;
}

.swiper-button-prev {
  transform: translateX(4px);
  &::after {
    transform: rotate(45deg);
  }
}

.swiper-button-next {
  transform: translateX(-4px);
  &::after {
    transform: rotate(-135deg)
  }
}

.swiper-pagination {
  left: 50% !important;
  bottom: 10px;
  transform: translateX(-50%);
  & .swiper-pagination-bullet {
    margin: 2px 3px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 1;
    &.swiper-pagination-bullet-active {
      background: rgba(255, 255, 255, 1); 
    }
  }
}

& .swiper-container {
    & .swiper-slide img {
        width: 100%; 
        height: 100%;
        object-fit: cover;
    }
}


`;

export default GlobalStyles;
